
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError } from 'rxjs';
import { ProductsService } from 'src/app/shared/service/product.service';
import { productDB } from 'src/app/shared/tables/product-list';
import { GuidedTourService } from 'ngx-guided-tour';
import { TourStep } from 'ngx-guided-tour';
import { APIService } from 'src/app/shared/service/apiService.service';
import Swal from 'sweetalert2';
import * as Notiflix from 'notiflix';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {

  public urlLanding: string = '';


  //public product_list = []
  //this.product_list = productDB.product;

  public url: string = '';
  public search: string = '';
  public product_list: any[] = [];
  public filteredProductList: any[] = []; // Lista filtrada de productos
  public filteredCourses: any[] = [];
  public totalProducts: number;
  public showFilter = false;
  public productId: number;
  public deleteIsSuccess = false;
  public selectedStatus: string = ''; // Estado seleccionado
  active: boolean;
  public video: any[] = [];
  private modalConfig: any = {
    ariaLabelledBy: 'modal-basic'
  };
  profile: any;
  Id: any;
  public isInstructor: boolean = false;
  public selectedCourseId: number; // ID del curso seleccionado para editar
  
  // Variables de paginación
  public currentPage: number = 1;
  public itemsPerPage: number = 10;
  public totalPages: number = 0;
  public paginatedCourses: any[] = [];
  public Math = Math; // Exponer Math para usar en el template
  public loading: boolean = false; // Estado de carga

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private productService: ProductsService,
    private guidedTourService: GuidedTourService,
    private apiService: APIService,
  ) { }

  filterCoursesByStatus() {
    // Ya no filtramos en frontend, ahora los filtros van al backend
    this.currentPage = 1; // Resetear a página 1
    this.loadData(); // Hacer nueva consulta con el filtro de status
  }


  ngOnInit() {
    const storedSearch = localStorage.getItem('searchValue');
    if (storedSearch) {
      this.search = storedSearch;
      this.showFilter = true;
    }
    this.loadData();
    this.loadVideos(); // Cargar el video para el tour
    this.checkUserRole();

    /* const user = JSON.parse(localStorage['currentUser']);

    this.apiService.getById(user.id).subscribe((data: any) => {
      this.profile = data;
      this.Id = this.profile.id;
      console.log('Info', this.Id);
    }); */

    // Inicia el tour después de asegurarse de que el video esté cargado
    setTimeout(() => {
      this.startTour();
    }, 1000);
  }

  private checkUserRole() {
    const user = JSON.parse(localStorage['currentUser']);
    this.isInstructor = user.roles === 'teacher'; // Ajusta esto según la estructura real de tu usuario
  }

  updateSearchValue(newValue: string) {
    this.search = newValue;
    if (this.search.trim()) {
      localStorage.setItem('searchValue', this.search);
    }
    this.loadData();
  }

  clearSearch() {
    this.search = '';
    this.selectedStatus = '';  // Limpiar el estado seleccionado
    localStorage.removeItem('searchValue');
    this.loadData();  // Recargar los datos después de limpiar los filtros
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  setModalContent(content: any, productId: number, status: boolean): void {
    this.productId = productId;
    this.active = status;
    this.modalService.open(content, this.modalConfig);
  }

  loadData() {
    this.loading = true; // Activar loading
    
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
    const isAdmin = user.roles === 'admin'; // Detectar si es admin
    
    // Construir objeto de filtros - solo agregar Status si está seleccionado
    const filters: any = {};
    if (this.selectedStatus) {
      // Enviar directamente en español como espera el backend
      filters.Status = this.selectedStatus;
    }
    
    console.log('🔍 Filtros enviados al backend (cursos):', filters);
    
    // El endpoint /courses tiene paginación del backend
    this.productService.getCourses2(this.search, user.id, this.currentPage, this.itemsPerPage, filters).subscribe(response => {
        console.log('📦 Respuesta COMPLETA de la API de cursos:', response);
        
        // El backend devuelve: { message: "...", data: [...], pagination: {...} }
        if (response && response.data && Array.isArray(response.data)) {
          console.log('✅ Estructura con data y paginación detectada:', response.message);
          
          this.product_list = response.data;
          this.filteredCourses = response.data;
          
          // Usar la paginación del backend
          if (response.pagination) {
            this.totalProducts = response.pagination.total;
            this.currentPage = response.pagination.page;
            this.totalPages = response.pagination.totalPages;
            console.log('📄 Paginación del backend:', response.pagination);
          } else {
            // Fallback si no viene pagination
            this.totalProducts = response.data.length;
            this.totalPages = Math.ceil(response.data.length / this.itemsPerPage);
          }
          
          // Los datos ya vienen paginados del backend, no paginar en frontend
          this.paginatedCourses = response.data;
          
          console.log(`✅ ${this.totalProducts} cursos totales - Mostrando ${this.paginatedCourses.length} en página ${this.currentPage} de ${this.totalPages}`);
        } else if (Array.isArray(response)) {
          // Fallback: Si devuelve array directo (por si acaso)
          console.log('✅ Array directo detectado (sin paginación)');
          this.product_list = response;
          this.filteredCourses = response;
          this.totalProducts = response.length;
          this.totalPages = Math.ceil(response.length / this.itemsPerPage);
          this.paginatedCourses = response;
        } else {
          console.warn('⚠️ Respuesta inesperada del servidor');
          this.product_list = [];
          this.filteredCourses = [];
          this.totalProducts = 0;
          this.totalPages = 0;
          this.paginatedCourses = [];
        }
        
        console.log('📦 Lista de cursos:', this.filteredCourses);
        
        this.loading = false; // Desactivar loading
    }, error => {
        console.error('❌ Error al cargar cursos:', error);
        this.loading = false; // Desactivar loading en caso de error
    });
  }

  loadVideos(): void {
    const currentUser = localStorage.getItem('currentUser');
  
    if (!currentUser) {
      console.error('El usuario actual no está definido en localStorage.');
      alert('No se pudo obtener la información del usuario.');
      return;
    }
  
    const user = JSON.parse(currentUser);
    const userId = user.id;
  
    if (!userId) {
      console.error('El UserId no está disponible.');
      alert('Hubo un problema al identificar al usuario.');
      return;
    }
  
    const requestBody = {
      descripcion: 'Cursos', // Solo buscamos el video con descripción "Cursos"
      userId: userId
    };
  
    this.productService.getVideos(requestBody).subscribe({
      next: (response) => {
        if (response) {
          const video = response[0]; // Toma el primer elemento del arreglo
          this.video = [video]; // Guarda el video en un arreglo (por consistencia)
        } else {
          console.error('No se encontró un video para "Cursos".');
        }
      },
      error: (err) => {
        console.error('Error al cargar el video:', err);
        alert('Hubo un problema al cargar el video. Inténtalo nuevamente.');
      }
    });
  }
  
  markVideoAsViewed(videoId: number): void {
    this.productService.changeStatusVideo(videoId).subscribe({
      next: () => {
        console.log(`El video con ID ${videoId} ha sido marcado como visto.`);
      },
      error: (err) => {
        console.error(`Error al cambiar el estado del video con ID ${videoId}:`, err);
        alert('Hubo un problema al actualizar el estado del video.');
      }
    });
  }
  
  startTour(): void {
    // Verifica si la lista de videos está vacía
    if (this.video.length === 0) {
      console.log('No hay videos disponibles para iniciar el tour.');
      return; // Detiene el inicio del tour
    }

    // Verifica si algún video ya ha sido visto - CON VALIDACIÓN
    const algunVideoVisto = this.video.some(video => 
      video?.OnboardingVideoUsers && 
      Array.isArray(video.OnboardingVideoUsers) && 
      video.OnboardingVideoUsers.length > 0 && 
      video.OnboardingVideoUsers[0]?.Viewed
    );

    if (algunVideoVisto) {
      console.log('El tour no se iniciará porque algunos videos ya han sido vistos.');
      return; // Detiene el inicio del tour
    }

    const tour = {
      tourId: 'CursosTour',
      useOrb: false, // Desactiva el orb
      steps: this.getGeneralSteps(),
      completeCallback: () => {
        console.log('Tour completado');
        if (this.video.length > 0) {
          const video = this.video[0];
          const videoUserId = video?.OnboardingVideoUsers?.[0]?.id;
          if (videoUserId) {
            this.markVideoAsViewed(videoUserId);
          }
        }
        this.router.navigate(['/products/courses']); // Redirige al nuevo componente
      },
      skipCallback: () => {
        console.log('Tour omitido');
        if (this.video.length > 0) {
          const video = this.video[0];
          const videoUserId = video?.OnboardingVideoUsers?.[0]?.id;
          if (videoUserId) {
            this.markVideoAsViewed(videoUserId);
          }
        }
        this.router.navigate(['/products/courses']); // Redirige al nuevo componente si se omite el tour
      }
    };
    document.querySelector('ngx-guided-tour')?.classList.add('cursos-tour');
    this.guidedTourService.startTour(tour); // Inicia el tour
  }
  
  getGeneralSteps(): TourStep[] {
    if (this.video.length > 0) {
      const video = this.video[0]; // Tomar el primer video cargado
      console.log('Videos:', video);
      
      // ✅ Validar que el video tenga la propiedad VideoUrl
      if (!video || !video.VideoUrl) {
        console.warn('⚠️ El video no tiene URL disponible');
        return []; // No mostrar el tour si no hay URL de video
      }
      
      return [
        {
          content: `
            <video controls width="100%" height="100%">
              <source src="${video.VideoUrl}" type="video/mp4">
              Tu navegador no soporta la reproducción de video.
            </video>
          `,
          title: 'Cursos',
          orientation: 'center', // Centrar el paso
          scrollAdjustment: 0 // Ajuste de desplazamiento
        }
      ];
    } else {
      return []; // Si no hay videos, no se muestra ningún paso
    }
  }    

  openAddCourseModal(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }

  openEditCourseModal(content: any, courseId: number) {
    this.selectedCourseId = courseId;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }

  sendToReview(courseId: any): void {
    Swal.fire({
        title: '¿Enviar a revisión?',
        text: 'El curso será enviado para revisión.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sí, enviar',
        cancelButtonText: 'Cancelar'
    }).then((result) => {
        if (result.isConfirmed) {
            this.productService.sendCourseToReview(courseId).subscribe({
                next: () => {
                    Swal.fire('Enviado', 'El curso ha sido enviado a revisión correctamente.', 'success');
                    this.loadData(); // Recargar la lista de cursos
                },
                error: (err) => {
                    Swal.fire('Error', 'No se pudo enviar el curso a revisión. Inténtalo nuevamente.', 'error');
                    console.error(err);
                }
            });
        }
    });
  }

  confirmDelete(productId: any): void {
    Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
    }).then((result) => {
        if (result.isConfirmed) {
            this.productService.deleteCourses(productId).subscribe({
                next: () => {
                    Swal.fire('Eliminado', 'El curso ha sido eliminado correctamente.', 'success');
                    this.loadData(); // Recargar la lista de cursos
                },
                error: (err) => {
                    Swal.fire('Error', 'No se pudo eliminar el curso. Inténtalo nuevamente.', 'error');
                    console.error(err);
                }
            });
        }
    });
  }
  
  
  copiarURL(courseSlug: string): void {
    const url = `${environment.WEBURL}landing/${courseSlug}`;
    navigator.clipboard.writeText(url)
      .then(() => {
        Notiflix.Notify.success('¡URL copiada al portapapeles!');
      })
      .catch(() => {
        Notiflix.Notify.failure('Error al copiar la URL');
      });
  }

  // Métodos de paginación
  updatePagination() {
    // Ya no necesitamos calcular paginación en frontend
    // El backend nos da totalPages
    this.paginatedCourses = this.filteredCourses;
  }

  paginateCourses() {
    // Ya no necesitamos paginar en frontend
    this.paginatedCourses = this.filteredCourses;
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      // Recargar datos del backend con la nueva página
      this.loadData();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      // Recargar datos del backend
      this.loadData();
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      // Recargar datos del backend
      this.loadData();
    }
  }

  getPageNumbers(): number[] {
    const pages: number[] = [];
    const maxPagesToShow = 5;
    let startPage = Math.max(1, this.currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(this.totalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  }
}
